/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_AdminInputs */



/**
* | output |
* | --- |
* | "Admin" |
*
* @param {Layout_Header_AdminInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_admin = /** @type {((inputs?: Layout_Header_AdminInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_AdminInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Admin")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Admin")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("管理")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("管理")
	if (locale === "ko") return /** @type {LocalizedString} */ ("관리자")
	return /** @type {LocalizedString} */ ("Admin")
});